var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('WorkflowsHero'),_c('WorkflowsFeatures'),_c('WorkflowsComparison'),_c('WorkflowsChatbots'),_c('WorkflowsWizard'),_c('WorkflowsEfficiency'),_c('RequestDemo',{attrs:{"msg":"See how Yabbr Workflows can free up your team’s time and supercharge your operations.","grey":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }